module.exports = __webpack_public_path__ + "img/logo_finanzas.8edae586.png";